module.exports = __webpack_public_path__ + "img/altered_404.c0f879da.svg";